import { render, staticRenderFns } from "./AppointmentDataTable.vue?vue&type=template&id=2b69ffdd&scoped=true"
import script from "./AppointmentDataTable.vue?vue&type=script&lang=js"
export * from "./AppointmentDataTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDataTable.vue?vue&type=style&index=0&id=2b69ffdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69ffdd",
  null
  
)

export default component.exports